import { render, staticRenderFns } from "./customInputType.vue?vue&type=template&id=21d5b5c8"
import script from "./customInputType.vue?vue&type=script&lang=js"
export * from "./customInputType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports